import { ConfigurationItemKind, } from "@plansoft-configuration-renderer/framework";
import { PluginHelper, } from "@plansoft-configuration-renderer/layout";
import { ConsoleLogger, LogLevels, } from "@plansoft-configuration-renderer/utils";
import { ConfigurationComponentType } from "../Configuration/ConfigurationComponentType";
import { composeGroupPath } from "./composeGroupPath";
const logger = new ConsoleLogger("NavigationState", LogLevels.warn);
export function findConfigurationItemParentsFromLayout(layout, configurationObject, options) {
    logger.debug("findConfigurationItemParentsFromLayout", configurationObject.path);
    return findFromRows(layout.rows, configurationObject, options);
}
function findFromRow(row, configurationObject, options) {
    return findFromLayoutCells(row.cells, configurationObject, options);
}
function findFromCell(cell, configurationObject, options) {
    // inspect attribute cells
    if (PluginHelper.isAttributePlugin(cell)) {
        return findFromAttributeCell(cell, configurationObject, options);
    }
    if (cell.rows == null) {
        return [];
    }
    const resultFromRow = findFromRows(cell.rows, configurationObject, options);
    if (resultFromRow.length === 0) {
        return [];
    }
    const pluginId = PluginHelper.getPluginId(cell);
    if (pluginId === ConfigurationComponentType.AttributeGroup) {
        const { title: id } = PluginHelper.getPluginProps(cell);
        return [
            {
                kind: ConfigurationItemKind.ConfigurationGroup,
                id,
                path: composeGroupPath({
                    configurationObjectPath: options.configurationObjectPath,
                    groupId: id,
                }),
                cellId: cell.id,
            },
            ...resultFromRow,
        ];
    }
    return resultFromRow;
}
function findFromAttributeCell(cell, configurationObject, options) {
    var _a, _b;
    const { identifier } = PluginHelper.getPluginProps(cell);
    const attribute = (_a = configurationObject.attributes) === null || _a === void 0 ? void 0 : _a.find((attr) => attr.id === identifier);
    // attribute not found in state
    if (attribute == null) {
        return [];
    }
    // exact matching attribute found
    if (attribute.path === options.attributePath) {
        return [
            {
                id: identifier,
                path: options.attributePath,
                kind: ConfigurationItemKind.ConfigurationAttribute,
                cellId: cell.id,
            },
        ];
    }
    // check for subconfiguration attribute containing the attribute found
    if (!options.attributePath.startsWith(attribute.path)) {
        return [];
    }
    // we found a matching subconfiguration attribute
    const attributeItemData = {
        kind: ConfigurationItemKind.ConfigurationAttribute,
        id: attribute.id,
        path: attribute.path,
        cellId: cell.id,
    };
    // look for the instances, needs includeValues in selector
    for (const subconfigurationObject of (_b = attribute.configurations) !== null && _b !== void 0 ? _b : []) {
        if (options.configurationObjectPath.startsWith(subconfigurationObject.path)) {
            return [
                attributeItemData,
                {
                    kind: ConfigurationItemKind.ConfigurationObject,
                    id: subconfigurationObject.id,
                    path: subconfigurationObject.path,
                },
            ];
        }
    }
    return [attributeItemData];
}
function findFromLayoutCells(cells, configurationObject, options) {
    for (const cell of cells) {
        const result = findFromCell(cell, configurationObject, options);
        if (result.length > 0) {
            return result;
        }
    }
    return [];
}
function findFromRows(rows, configurationObject, options) {
    for (const row of rows) {
        const result = findFromRow(row, configurationObject, options);
        if (result.length > 0) {
            return result;
        }
    }
    return [];
}
//# sourceMappingURL=findConfigurationItemParentsFromLayout.js.map